// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57eb2f67","732":"98ebe64b","977":"e0c17cea"}[chunkId] + ".chunk.js";
};